import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Dashboard',
        predictions: 'Predictions',
        lastManStanding: 'Last Man Standing',
        worldCup: 'World Cup',
        wcMatchPredictions: 'WC Scores',
        wcSurvivor: 'WC Survivor',
        leagues: 'Leagues',
        admin: 'Admin Panel',
        profile: 'Profile',
        logout: 'Logout',
      },
      // Auth
      auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        displayName: 'Display Name',
        displayNamePlaceholder: 'Your name (shown to other players)',
        loginButton: 'Sign In',
        registerButton: 'Create Account',
        noAccount: "Don't have an account?",
        haveAccount: 'Already have an account?',
        switchToRegister: 'Register here',
        switchToLogin: 'Login here',
      },
      // Landing
      landing: {
        hero: 'PREDICT. COMPETE. WIN.',
        subtitle: 'Join the ultimate football prediction competition',
        cta: 'Get Started',
        feature1Title: 'Prediction League',
        feature1Desc: 'Score points for correct results and exact scores',
        feature2Title: 'Last Man Standing',
        feature2Desc: 'One wrong pick and you\'re out. Can you survive?',
        feature3Title: 'Private Leagues',
        feature3Desc: 'Create leagues with friends and compete for glory',
      },
      // Dashboard
      dashboard: {
        welcome: 'Welcome back',
        yourStats: 'Your Stats',
        totalPoints: 'Total Points',
        weeklyRank: 'Weekly Rank',
        monthlyRank: 'Monthly Rank',
        lmsStatus: 'LMS Status',
        alive: 'Alive',
        eliminated: 'Eliminated',
        upcomingMatches: 'Upcoming Matches',
        recentPredictions: 'Recent Predictions',
        leaderboard: 'Leaderboard',
      },
      // Predictions
      predictions: {
        title: 'Make Your Predictions',
        upcoming: 'Upcoming Matches',
        yourPredictions: 'Your Predictions',
        home: 'Home',
        away: 'Away',
        predict: 'Predict',
        save: 'Save Prediction',
        points: 'Points',
        correctResult: '1pt for correct result',
        exactScore: '3pts for exact score',
        locked: 'Match Started',
      },
      // Last Man Standing
      lms: {
        title: 'Last Man Standing',
        pickTeam: 'Pick Your Team',
        currentWeek: 'Week',
        survivors: 'Survivors',
        eliminated: 'Eliminated',
        yourPick: 'Your Pick',
        selectTeam: 'Select a team for this week',
        alreadyPicked: 'Already picked',
        confirmPick: 'Confirm Pick',
        rules: 'Rules: Pick one team each week. You cannot pick the same team twice. One wrong prediction and you\'re eliminated!',
      },
      // World Cup
      worldCup: {
        title: 'World Cup 2026 Predictions',
        subtitle: 'Predict the top 4 teams of the FIFA World Cup 2026',
        winner: 'Winner',
        runnerUp: 'Runner-up',
        thirdPlace: '3rd Place',
        fourthPlace: '4th Place',
        totalGoals: 'Total Goals in Tournament',
        totalGoalsDesc: 'Tiebreaker: predict total goals scored in the entire World Cup',
        selectTeam: 'Select a team',
        submit: 'Submit Prediction',
        update: 'Update Prediction',
        locked: 'Predictions Locked',
        lockedDesc: 'The deadline for predictions has passed (June 10, 2026 BST)',
        deadline: 'Deadline',
        yourPrediction: 'Your Prediction',
        noPrediction: 'You haven\'t made a prediction yet',
        leaderboard: 'Leaderboard',
        noResults: 'Results have not been entered yet',
        correctPositions: 'Correct Positions',
        goalsDiff: 'Goals Difference',
        allTeams: 'All Teams',
        filterByConf: 'Filter by confederation',
        predictionsCount: 'Total Predictions',
        searchTeams: 'Search teams...',
      },
      // WC Last Man Standing
      wcLms: {
        title: 'WC Last Man Standing',
        subtitle: 'Pick one winning team each match day. Get it wrong and you\'re eliminated!',
        eliminated: 'You\'ve been eliminated!',
        eliminatedOn: 'Eliminated on match day',
        alive: 'You\'re still in!',
        correctOf: 'correct picks out of',
        noMatches: 'No matches scheduled yet',
        noMatchesDesc: 'World Cup 2026 matches will appear here once the schedule is set.',
        matchDays: 'Match Days',
        yourPick: 'Your pick for',
        correct: 'Correct',
        wrong: 'Wrong',
        pending: 'Pending',
        lockInPick: 'Lock In Pick',
        updatePick: 'Update Pick',
        saving: 'Saving...',
        standings: 'Standings',
        player: 'Player',
        total: 'Total',
        status: 'Status',
        selectMatch: 'Select a match and a team to win',
        games: 'games',
        vs: 'VS',
        aliveLabel: 'Alive',
        eliminatedLabel: 'Eliminated',
      },
      // Dashboard Promos
      dashboardPromo: {
        wcPredTitle: 'World Cup 2026 Predictions',
        wcPredLive: 'Live Now',
        wcPredDesc: 'Predict the Winner, Runner-up, 3rd and 4th place of the FIFA World Cup 2026. The tiebreaker is the total goals in the tournament. Share your prediction with friends!',
        wcPredCta: 'Make Your Prediction',
        wcLmsTitle: 'World Cup Last Man Standing',
        comingSoon: 'Coming Soon',
        wcLmsDesc: 'Pick one winning team each match day of the World Cup 2026. Get it wrong and you\'re eliminated! No restrictions on repeating teams. Can you be the last one standing?',
        starts: 'Starts',
        wcMatchTitle: 'WC Score Predictions',
        wcMatchDesc: 'Predict the exact score of every World Cup 2026 match. 10 points for an exact score, 3 points for the correct result.',
      },
      profile: {
        editName: 'Edit display name',
        clickToEdit: 'Tap the pencil to change your display name',
        nameUpdated: 'Display name updated!',
        nameError: 'Name must be 1-30 characters',
      },
      // Prize
      prize: {
        winnerTakes: 'Winner Takes All',
        headline: 'Win an Official Jersey of Your Choice',
        description: 'The winner of each competition takes home an official football shirt. Pick any country in the world, a Birmingham City shirt, or a Santos FC shirt. Free postage & packaging worldwide.',
        tagline: 'Prize: Official Jersey of Your Choice',
        jerseyChoice: 'Any country, Birmingham City, or Santos FC — free worldwide delivery',
        countryJersey: 'Any Country',
        freeWorldwide: 'Free P&P Worldwide',
        freeShipping: 'Free worldwide delivery',
      },
      // Share
      share: {
        shareLink: 'Share Link',
        linkCopied: 'Link Copied!',
        viewDownload: 'View & Download Card',
        whatsapp: 'WhatsApp',
        downloadCard: 'Download Card',
        shareWhatsapp: 'Share on WhatsApp',
        makePrediction: 'Make Your Prediction',
        notFound: 'Prediction not found',
        goHome: 'Go to The Kings Head Predictions',
        prediction: 'Prediction',
        totalGoals: 'Total Tournament Goals',
      },
      // WC Match Predictions
      wcMatch: {
        title: 'WC Score Predictions',
        subtitle: 'Predict the score of every World Cup 2026 match',
        exactScore: 'Exact score',
        correctResult: 'Correct result (win/draw)',
        predictions: 'Predictions',
        leaderboard: 'Leaderboard',
        group: 'Group',
        finalScore: 'Final',
        savePredictions: 'Save Predictions',
        saved: '{{count}} predictions saved!',
        noPredictions: 'Enter at least one score prediction',
        preds: 'Preds',
        noEntries: 'No predictions yet',
      },
      leagues: {
        title: 'Leagues',
        global: 'Global League',
        private: 'Private Leagues',
        create: 'Create League',
        join: 'Join League',
        myLeagues: 'My Leagues',
        leagueName: 'League Name',
        leagueCode: 'League Code',
        members: 'Members',
        weekly: 'Weekly',
        monthly: 'Monthly',
        yearly: 'Yearly',
        noLeagues: 'No private leagues yet',
        selectLeague: 'Select a league to view leaderboard',
        enterName: 'Please enter a league name',
        enterCode: 'Please enter a league code',
        joinedSuccess: 'Joined league!',
        joinDescription: 'Enter the invite code shared by the league creator',
        leagueCreated: 'League Created!',
        shareCodeDescription: 'Share this invite code with friends so they can join your league',
        inviteCode: 'Invite Code',
        copied: 'Copied!',
        copyCode: 'Copy Code',
        codeCopied: 'Code copied to clipboard!',
        shareWhatsApp: 'Share via WhatsApp',
        whatsappMessage: 'Join my league "{{name}}" on The Kings Head Predictions! Use invite code: {{code}}',
      },
      // Admin
      admin: {
        title: 'Admin Panel',
        matches: 'Matches',
        teams: 'Teams',
        addMatch: 'Add Match',
        addTeam: 'Add Team',
        updateResult: 'Update Result',
        homeTeam: 'Home Team',
        awayTeam: 'Away Team',
        date: 'Date',
        status: 'Status',
        scheduled: 'Scheduled',
        completed: 'Completed',
        homeScore: 'Home Score',
        awayScore: 'Away Score',
        teamName: 'Team Name',
        teamLogo: 'Team Logo URL',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        leagues: 'Leagues',
        allLeagues: 'All Leagues',
        totalLeagues: 'leagues',
        noLeagues: 'No leagues created yet',
        createdBy: 'Created by',
        membersList: 'Members',
        creator: 'Creator',
        remove: 'Remove',
        confirmDeleteLeague: 'Delete league "{{name}}" and all its data?',
        confirmRemoveMember: 'Remove {{email}} from this league?',
        leagueDeleted: 'League deleted',
        memberRemoved: 'Member removed',
        syncResults: 'Sync Live Results',
        syncing: 'Syncing...',
        syncSuccess: '{{count}} match results synced!',
        syncUpToDate: 'All results up to date',
        syncError: 'Sync failed',
        lastSync: 'Last sync',
        autoSync: 'Auto-sync every 5 min',
      },
      // Common
      common: {
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        confirm: 'Confirm',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        search: 'Search',
        filter: 'Filter',
        rank: 'Rank',
        player: 'Player',
        points: 'Points',
        join: 'Join',
        create: 'Create',
        done: 'Done',
      },
    },
  },
  pt: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Painel',
        predictions: 'Previsões',
        lastManStanding: 'Último a Sobreviver',
        worldCup: 'Copa do Mundo',
        wcMatchPredictions: 'Placares Copa',
        wcSurvivor: 'Sobrevivente',
        leagues: 'Ligas',
        admin: 'Painel Admin',
        profile: 'Perfil',
        logout: 'Sair',
      },
      // Auth
      auth: {
        login: 'Entrar',
        register: 'Registrar',
        email: 'E-mail',
        password: 'Senha',
        confirmPassword: 'Confirmar Senha',
        loginButton: 'Entrar',
        registerButton: 'Criar Conta',
        noAccount: 'Não tem uma conta?',
        haveAccount: 'Já tem uma conta?',
        switchToRegister: 'Registre-se aqui',
        switchToLogin: 'Entre aqui',
      },
      // Landing
      landing: {
        hero: 'PREVEJA. COMPITA. GANHE.',
        subtitle: 'Participe da melhor competição de previsões de futebol',
        cta: 'Começar',
        feature1Title: 'Liga de Previsões',
        feature1Desc: 'Ganhe pontos por resultados corretos e placares exatos',
        feature2Title: 'Último a Sobreviver',
        feature2Desc: 'Uma escolha errada e você está fora. Consegue sobreviver?',
        feature3Title: 'Ligas Privadas',
        feature3Desc: 'Crie ligas com amigos e compita pela glória',
      },
      // Dashboard
      dashboard: {
        welcome: 'Bem-vindo de volta',
        yourStats: 'Suas Estatísticas',
        totalPoints: 'Pontos Totais',
        weeklyRank: 'Rank Semanal',
        monthlyRank: 'Rank Mensal',
        lmsStatus: 'Status LMS',
        alive: 'Vivo',
        eliminated: 'Eliminado',
        upcomingMatches: 'Próximas Partidas',
        recentPredictions: 'Previsões Recentes',
        leaderboard: 'Classificação',
      },
      // Predictions
      predictions: {
        title: 'Faça Suas Previsões',
        upcoming: 'Próximas Partidas',
        yourPredictions: 'Suas Previsões',
        home: 'Casa',
        away: 'Fora',
        predict: 'Prever',
        save: 'Salvar Previsão',
        points: 'Pontos',
        correctResult: '1pt por resultado correto',
        exactScore: '3pts por placar exato',
        locked: 'Partida Iniciada',
      },
      // Last Man Standing
      lms: {
        title: 'Último a Sobreviver',
        pickTeam: 'Escolha Seu Time',
        currentWeek: 'Semana',
        survivors: 'Sobreviventes',
        eliminated: 'Eliminados',
        yourPick: 'Sua Escolha',
        selectTeam: 'Selecione um time para esta semana',
        alreadyPicked: 'Já escolhido',
        confirmPick: 'Confirmar Escolha',
        rules: 'Regras: Escolha um time por semana. Não pode escolher o mesmo time duas vezes. Uma previsão errada e você está eliminado!',
      },
      // World Cup
      worldCup: {
        title: 'Previsões Copa do Mundo 2026',
        subtitle: 'Preveja os 4 primeiros classificados da Copa do Mundo FIFA 2026',
        winner: 'Campeão',
        runnerUp: 'Vice-campeão',
        thirdPlace: '3º Lugar',
        fourthPlace: '4º Lugar',
        totalGoals: 'Total de Gols no Torneio',
        totalGoalsDesc: 'Desempate: preveja o total de gols marcados em toda a Copa do Mundo',
        selectTeam: 'Selecione um time',
        submit: 'Enviar Previsão',
        update: 'Atualizar Previsão',
        locked: 'Previsões Encerradas',
        lockedDesc: 'O prazo para previsões expirou (10 de junho de 2026 BST)',
        deadline: 'Prazo',
        yourPrediction: 'Sua Previsão',
        noPrediction: 'Você ainda não fez uma previsão',
        leaderboard: 'Classificação',
        noResults: 'Os resultados ainda não foram inseridos',
        correctPositions: 'Posições Corretas',
        goalsDiff: 'Diferença de Gols',
        allTeams: 'Todos os Times',
        filterByConf: 'Filtrar por confederação',
        predictionsCount: 'Total de Previsões',
        searchTeams: 'Buscar times...',
      },
      // WC Last Man Standing
      wcLms: {
        title: 'Último a Sobreviver - Copa',
        subtitle: 'Escolha um time vencedor a cada dia de jogo. Errou? Está eliminado!',
        eliminated: 'Você foi eliminado!',
        eliminatedOn: 'Eliminado no dia de jogo',
        alive: 'Você ainda está vivo!',
        correctOf: 'acertos de',
        noMatches: 'Nenhuma partida agendada',
        noMatchesDesc: 'As partidas da Copa do Mundo 2026 aparecerão aqui quando o calendário for definido.',
        matchDays: 'Dias de Jogo',
        yourPick: 'Sua escolha para',
        correct: 'Correto',
        wrong: 'Errado',
        pending: 'Pendente',
        lockInPick: 'Confirmar Escolha',
        updatePick: 'Atualizar Escolha',
        saving: 'Salvando...',
        standings: 'Classificação',
        player: 'Jogador',
        total: 'Total',
        status: 'Status',
        selectMatch: 'Selecione uma partida e um time vencedor',
        games: 'jogos',
        vs: 'VS',
        aliveLabel: 'Vivo',
        eliminatedLabel: 'Eliminado',
      },
      // Dashboard Promos
      dashboardPromo: {
        wcPredTitle: 'Previsões Copa do Mundo 2026',
        wcPredLive: 'Ao Vivo',
        wcPredDesc: 'Preveja o Campeão, Vice, 3º e 4º lugar da Copa do Mundo FIFA 2026. O desempate é o total de gols no torneio. Compartilhe sua previsão com amigos!',
        wcPredCta: 'Faça Sua Previsão',
        wcLmsTitle: 'Último a Sobreviver - Copa',
        comingSoon: 'Em Breve',
        wcLmsDesc: 'Escolha um time vencedor a cada dia de jogo da Copa do Mundo 2026. Errou? Está eliminado! Sem restrições de repetição de times. Será que você sobrevive?',
        starts: 'Início',
        wcMatchTitle: 'Placares da Copa',
        wcMatchDesc: 'Preveja o placar exato de cada jogo da Copa do Mundo 2026. 10 pontos para placar exato, 3 pontos para resultado correto.',
      },
      profile: {
        editName: 'Editar nome de exibição',
        clickToEdit: 'Toque no lápis para alterar seu nome',
        nameUpdated: 'Nome de exibição atualizado!',
        nameError: 'O nome deve ter de 1 a 30 caracteres',
      },
      // Prize
      prize: {
        winnerTakes: 'O Vencedor Leva Tudo',
        headline: 'Ganhe uma Camisa Oficial à Sua Escolha',
        description: 'O vencedor de cada competição leva para casa uma camisa oficial de futebol. Escolha qualquer seleção do mundo, uma camisa do Birmingham City ou do Santos FC. Frete grátis para todo o mundo.',
        tagline: 'Prêmio: Camisa Oficial à Sua Escolha',
        jerseyChoice: 'Qualquer seleção, Birmingham City ou Santos FC — entrega mundial gratuita',
        countryJersey: 'Qualquer Seleção',
        freeWorldwide: 'Frete Grátis Mundial',
        freeShipping: 'Entrega mundial gratuita',
      },
      // Share
      share: {
        shareLink: 'Compartilhar Link',
        linkCopied: 'Link Copiado!',
        viewDownload: 'Ver e Baixar Card',
        whatsapp: 'WhatsApp',
        downloadCard: 'Baixar Card',
        shareWhatsapp: 'Compartilhar no WhatsApp',
        makePrediction: 'Faça Sua Previsão',
        notFound: 'Previsão não encontrada',
        goHome: 'Ir para The Kings Head Predictions',
        prediction: 'Previsão',
        totalGoals: 'Total de Gols no Torneio',
      },
      // WC Match Predictions
      wcMatch: {
        title: 'Placares da Copa',
        subtitle: 'Preveja o placar de cada jogo da Copa do Mundo 2026',
        exactScore: 'Placar exato',
        correctResult: 'Resultado correto (vitória/empate)',
        predictions: 'Previsões',
        leaderboard: 'Classificação',
        group: 'Grupo',
        finalScore: 'Final',
        savePredictions: 'Salvar Previsões',
        saved: '{{count}} previsões salvas!',
        noPredictions: 'Insira pelo menos um placar',
        preds: 'Prevs',
        noEntries: 'Nenhuma previsão ainda',
      },
      leagues: {
        global: 'Liga Global',
        private: 'Ligas Privadas',
        create: 'Criar Liga',
        join: 'Entrar na Liga',
        myLeagues: 'Minhas Ligas',
        leagueName: 'Nome da Liga',
        leagueCode: 'Código da Liga',
        members: 'Membros',
        weekly: 'Semanal',
        monthly: 'Mensal',
        yearly: 'Anual',
        noLeagues: 'Nenhuma liga privada ainda',
        selectLeague: 'Selecione uma liga para ver a classificação',
        enterName: 'Por favor, insira o nome da liga',
        enterCode: 'Por favor, insira o código da liga',
        joinedSuccess: 'Entrou na liga!',
        joinDescription: 'Insira o código de convite compartilhado pelo criador da liga',
        leagueCreated: 'Liga Criada!',
        shareCodeDescription: 'Compartilhe este código de convite com amigos para que possam entrar na sua liga',
        inviteCode: 'Código de Convite',
        copied: 'Copiado!',
        copyCode: 'Copiar Código',
        codeCopied: 'Código copiado!',
        shareWhatsApp: 'Compartilhar via WhatsApp',
        whatsappMessage: 'Entre na minha liga "{{name}}" no The Kings Head Predictions! Use o código: {{code}}',
      },
      // Admin
      admin: {
        title: 'Painel Admin',
        matches: 'Partidas',
        teams: 'Times',
        addMatch: 'Adicionar Partida',
        addTeam: 'Adicionar Time',
        updateResult: 'Atualizar Resultado',
        homeTeam: 'Time da Casa',
        awayTeam: 'Time Visitante',
        date: 'Data',
        status: 'Status',
        scheduled: 'Agendado',
        completed: 'Concluído',
        homeScore: 'Gols Casa',
        awayScore: 'Gols Fora',
        teamName: 'Nome do Time',
        teamLogo: 'URL do Logo',
        save: 'Salvar',
        cancel: 'Cancelar',
        edit: 'Editar',
        delete: 'Excluir',
        leagues: 'Ligas',
        allLeagues: 'Todas as Ligas',
        totalLeagues: 'ligas',
        noLeagues: 'Nenhuma liga criada ainda',
        createdBy: 'Criado por',
        membersList: 'Membros',
        creator: 'Criador',
        remove: 'Remover',
        confirmDeleteLeague: 'Excluir liga "{{name}}" e todos os seus dados?',
        confirmRemoveMember: 'Remover {{email}} desta liga?',
        leagueDeleted: 'Liga excluída',
        memberRemoved: 'Membro removido',
        syncResults: 'Sincronizar Resultados',
        syncing: 'Sincronizando...',
        syncSuccess: '{{count}} resultados sincronizados!',
        syncUpToDate: 'Todos os resultados atualizados',
        syncError: 'Falha na sincronização',
        lastSync: 'Última sincronização',
        autoSync: 'Sincronização automática a cada 5 min',
      },
      // Common
      common: {
        loading: 'Carregando...',
        error: 'Erro',
        success: 'Sucesso',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        save: 'Salvar',
        delete: 'Excluir',
        edit: 'Editar',
        close: 'Fechar',
        search: 'Buscar',
        filter: 'Filtrar',
        rank: 'Posição',
        player: 'Jogador',
        points: 'Pontos',
        join: 'Entrar',
        create: 'Criar',
        done: 'Pronto',
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
